/**
 * Returns formatted currency based on float val
 * @param {number} number
 * @param {object} [opts] options
 * @param {string} [opts.currency] currency
 * @param {string} [opts.style] style
 * @param {int} [opts.maximumSignificantDigits] digits
 * @returns {string}
 */
export const formatNumber = (number, opts = {}) => {
  if (Number.isNaN(number) || number === null || number === undefined) {
    return '';
  }

  const options = {
    maximumFractionDigits: 2,
    ...opts
  };

  if (opts.currency) {
    options.style = 'currency';
    options.currencyDisplay = options.currencyDisplay ? options.currencyDisplay : 'narrowSymbol';
  }

  return new Intl.NumberFormat(options.locale || 'ro-US', options).format(number);
};

/**
 * Returns formatted date
 * @param {Date|number|string} date
 * @param {object} opts
 * @returns {string}
 */
export const formatDate = (date, opts = {}) => {
  if (!date) return '-';

  const options = {
    dateStyle: 'short',
    timeStyle: 'short',
    ...opts,
  };

  try {
    // FIX: Safari does not support date format with timezone
    const parsedDate = new Date(
      String(date).replace(/\+.*$|\..*$/, '').replace(' ', 'T')
    );

    if (Number.isNaN(parsedDate.getTime())) return '-';

    return new Intl.DateTimeFormat(options.locale || 'ro-US', options).format(parsedDate);
  } catch {
    return '-';
  }
};
